var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import styles from '../../@patternfly/patternfly-next/layouts/Page/page.css.js';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import BarsIcon from '@patternfly/react-icons/dist/esm/icons/bars-icon';

import { Button, ButtonVariant } from '../../components/Button';
import { PageContext } from './Page';

var propTypes = {
  /** Additional classes added to the page header */
  className: PropTypes.string,
  /** Component to render the logo/brand (e.g. <Brand />) */
  logo: PropTypes.node,
  /** Additional props passed to the logo anchor container */
  logoProps: PropTypes.object,
  /** Component to render the toolbar (e.g. <Toolbar />) */
  toolbar: PropTypes.node,
  /** Component to render the avatar (e.g. <Avatar /> */
  avatar: PropTypes.node,
  /** Component to render navigation within the header (e.g. <Nav /> */
  topNav: PropTypes.node,
  /** True to show the nav toggle button (toggles side nav) */
  showNavToggle: PropTypes.bool,
  /** Callback function to handle the side nav toggle button */
  onNavToggle: PropTypes.func,
  /** header should have tall modifier */
  isTall: PropTypes.bool
};

var defaultProps = {
  className: '',
  logo: null,
  logoProps: null,
  toolbar: null,
  avatar: null,
  topNav: null,
  showNavToggle: false,
  onNavToggle: function onNavToggle() {
    return undefined;
  },
  isTall: false
};

/* Added temporary style as a workaround to make dropdowns work until fix is made (patternfly-next #780) */
var PageHeader = function PageHeader(_ref) {
  var className = _ref.className,
      logo = _ref.logo,
      logoProps = _ref.logoProps,
      toolbar = _ref.toolbar,
      avatar = _ref.avatar,
      topNav = _ref.topNav,
      showNavToggle = _ref.showNavToggle,
      onNavToggle = _ref.onNavToggle,
      isTall = _ref.isTall,
      props = _objectWithoutProperties(_ref, ['className', 'logo', 'logoProps', 'toolbar', 'avatar', 'topNav', 'showNavToggle', 'onNavToggle', 'isTall']);

  return React.createElement(
    PageContext.Consumer,
    null,
    function (context) {
      return React.createElement(
        'header',
        _extends({
          role: 'banner',
          className: css(styles.pageHeader, (context && context.isTall || isTall) && styles.modifiers.tall, className)
        }, props),
        React.createElement(
          'div',
          { className: css(styles.pageHeaderBrand) },
          showNavToggle && React.createElement(
            'div',
            { className: css(styles.pageHeaderBrandToggle) },
            React.createElement(
              Button,
              {
                id: 'nav-toggle',
                onClick: onNavToggle,
                'aria-label': 'Toggle primary navigation',
                variant: ButtonVariant.plain
              },
              React.createElement(BarsIcon, null)
            )
          ),
          React.createElement(
            'a',
            _extends({ className: css(styles.pageHeaderBrandLink) }, logoProps),
            logo
          )
        ),
        topNav && React.createElement(
          'div',
          { className: css(styles.pageHeaderNav) },
          topNav
        ),
        React.createElement(
          'div',
          { className: css(styles.pageHeaderTools) },
          toolbar,
          avatar
        )
      );
    }
  );
};

PageHeader.propTypes = propTypes;
PageHeader.defaultProps = defaultProps;

export default PageHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/layouts/Page/PageHeader.js
// module id = 300
// module chunks = 0